module.exports = __webpack_public_path__ + "static/Fold 07-8bfda7bab4b10b3cee502502e2947e54.png";